import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import { toAbsoluteLink, toUserProfileLink } from 'lib/links';
import { toFormattedJsonLdString } from 'lib/string';

const ArticleHead = ({
  articleDescription,
  articleImage,
  articleModifiedDate,
  articlePublished,
  articleTags = [],
  articleTitle,
  categoryName,
  metaDescription = null,
  metaTitle = null,
  userUsername,
}) => (
  <NextSeo
    description={
      toFormattedJsonLdString(metaDescription) ??
      toFormattedJsonLdString(articleDescription)
    }
    openGraph={{
      title: toFormattedJsonLdString(articleTitle),
      description: toFormattedJsonLdString(articleDescription),
      type: 'article',
      article: {
        publishedTime: articlePublished,
        modifiedTime: articleModifiedDate,
        section: categoryName,
        authors: [toAbsoluteLink(toUserProfileLink(userUsername))],
        tags:
          articleTags.length > 0
            ? articleTags.map(({ tagName }) => tagName)
            : [],
      },
      images: [
        {
          url: articleImage,
          alt: toFormattedJsonLdString(articleTitle),
          height: 502,
          width: 896,
        },
      ],
    }}
    title={
      toFormattedJsonLdString(metaTitle) ||
      toFormattedJsonLdString(articleTitle)
    }
  />
);

ArticleHead.propTypes = {
  articleDescription: PropTypes.string.isRequired,
  articleImage: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  articleModifiedDate: PropTypes.string.isRequired,
  articlePublished: PropTypes.string.isRequired,
  articleTags: PropTypes.arrayOf(
    PropTypes.shape({
      tagId: PropTypes.string.isRequired,
      tagName: PropTypes.string.isRequired,
      tagSlug: PropTypes.string.isRequired,
    })
  ),
  categoryName: PropTypes.string.isRequired,
  metaDescription: PropTypes.string,
  metaTitle: PropTypes.string,
  userUsername: PropTypes.string.isRequired,
};

export default ArticleHead;
